import React from 'react'
import DSDirectTest from '../components/test/DSDirectTest'

const DSDirectTestPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <DSDirectTest />
    </div>
  )
}

export default DSDirectTestPage